import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Layout({ children, className = "" }) {
    return _jsx("div", { className: `bg-background flex min-h-screen flex-col ${className}`, children: children });
}
export function Container({ children, className = "", size = "lg" }) {
    const sizeClasses = {
        sm: "max-w-sm",
        md: "max-w-md",
        lg: "max-w-4xl",
        xl: "max-w-6xl",
        full: "max-w-full",
    };
    return _jsx("div", { className: `mx-auto px-4 sm:px-6 lg:px-8 ${sizeClasses[size]} ${className}`, children: children });
}
export function Header({ children, className = "", sticky = false }) {
    const stickyClasses = sticky ? "sticky top-0 z-40" : "";
    return _jsx("header", { className: `bg-surface border-border border-b ${stickyClasses} ${className}`, children: children });
}
export function Main({ children, className = "" }) {
    return _jsx("main", { className: `flex-1 ${className}`, children: children });
}
export function Footer({ children, className = "" }) {
    return _jsx("footer", { className: `bg-surface border-border border-t ${className}`, children: children });
}
export function Sidebar({ children, className = "", isOpen = true }) {
    return (_jsx("aside", { className: `bg-surface border-border border-r transition-transform duration-200 ${isOpen ? "translate-x-0" : "-translate-x-full"} ${className}`, children: children }));
}
export function Page({ children, title, className = "" }) {
    return (_jsxs("div", { className: `bg-surface min-h-full flex-1 ${className}`, children: [title && (_jsx("div", { className: "border-border border-b px-4 py-4 sm:px-6", children: _jsx("h1", { className: "text-textPrimary text-2xl font-bold", children: title }) })), _jsx("div", { className: "p-4 sm:p-6", children: children })] }));
}
